module.exports = window["wcPPCP"]["product"];